import React, { PropTypes, Component } from 'react'
import TimeSheet from 'components/timesheet'
import styles from './styles'
import ContentSelect from 'components/contentSelect'
import Snackbar from 'react-toolbox/lib/snackbar'
import { aProjects, aTasks, aRecords, aUsers, aWeekReports, aDates } from 'utils/aUtils'
import misc from 'utils/misc'
import co from 'co'

class TimeSheetPage extends Component {

  static propTypes = {
    me: PropTypes.object,
  };

  constructor (props, context) {
    super(props, context)
    this.onRecordUpdate = this.onRecordUpdate.bind(this)
    this.onShowChange = this.onShowChange.bind(this)
    this.onSnackbarClick = this.onSnackbarClick.bind(this)
    this.onSnackbarTimeout = this.onSnackbarTimeout.bind(this)
    this.onWeekChange = this.onWeekChange.bind(this)
    this.onImportLastWeek = ::this.onImportLastWeek
    this.onWeekReportChange = ::this.onWeekReportChange
    this.onContentCodeChange = ::this.onContentCodeChange
  }

  state = {
    userId: 0,
    thisMonday: { year: 2016, month: 2, date: 1 },
    snackbarActive: false,
    snackbarText: '',
    records: [],
    users: [],
    projects: [],
    tasks: [],
    dates: [],
    weekReport: {},
    projectShow: [],
    taskShow: {},
  };

  componentWillMount () {
    const _this = this
    const me = this.props.me
    co(function *() {
      const monday = misc.getMondayByMs(new Date)
      const { users, projects, tasks, dates, records, weekReports } = yield {
        users: aUsers.find(),
        projects: aProjects.find(),
        tasks: aTasks.find(),
        dates: aDates.find(),
        records: aRecords.findWeek(me._id, monday),
        weekReports: aWeekReports.find(me._id, monday),
      }
      const userId = me._id
      let weekReport = {}
      if (weekReports.length > 0) {
        weekReport = weekReports[0]
      }

      _this.setState({
        userId,
        records,
        users,
        projects,
        tasks,
        dates,
        weekReport,
        thisMonday: monday,
      })
    }).catch(misc.onError)
  }

  onImportLastWeek () {
    const { thisMonday, projects, tasks } = this.state
    const me = this.props.me
    const _this = this

    const pEnabled = misc.getDict(projects, 'stage')
    const tEnabled = misc.getDict(tasks, 'isEnabled')

    co(function *() {
      const monday = misc.getShiftedMonday(thisMonday, -1)
      const records = yield aRecords.findWeek(me._id, monday)

      const projectShow = []
      const taskShow = {}
      const updateShowByRecord = record => {
        const { projectId, taskId } = record
        // 不匯入非啟用中的專案和內容代碼
        if (pEnabled[projectId] !== '1' || tEnabled[taskId] !== true) {
          _this.setState({ snackbarActive: true, snackbarText: '部分專案/內容代碼已停用、未匯入' })
          return
        }

        if (!projectShow.includes(projectId)) {
          projectShow.push(projectId)
        }

        if (!taskShow.hasOwnProperty(projectId)) {
          taskShow[projectId] = []
        }

        if (!taskShow[projectId].includes(taskId)) {
          taskShow[projectId].push(taskId)
        }
      }
      records.forEach(updateShowByRecord)

      // sort according to pid and tid
      projectShow.sort()
      projectShow.forEach(pid => {
        if (taskShow[pid]) {
          taskShow[pid].sort()
        }
      })
      _this.setState({ projectShow, taskShow })
    }).catch(misc.onError)
  }

  onSnackbarClick () {
    this.setState({ snackbarActive: false })
  }

  onSnackbarTimeout () {
    this.setState({ snackbarActive: false })
  }

  onRecordUpdate (record) {
    const newRecord = misc.deepCopy(record)
    const recordIndex = misc.findRecordIndex(record, this.state.records)
    const isRecordFound = recordIndex >= 0
    const isRecordEmpty = misc.isRecordEmpty(record)
    const ActionType = TimeSheetPage.RecordActionType
    let action

    if (isRecordFound) {
      newRecord._id = this.state.records[recordIndex]._id
    }

    if (isRecordFound && isRecordEmpty) {
      action = ActionType.del
    }
    if (isRecordFound && !isRecordEmpty) {
      action = ActionType.update
    }
    if (!isRecordFound && isRecordEmpty) {
      return
    }
    if (!isRecordFound && !isRecordEmpty) {
      action = ActionType.create
    }

    this.updateClientState(newRecord, action)
    this.updateServerState(newRecord, action)
  }

  onShowChange (type, data) {
    const ActionType = ContentSelect.ActionType
    const projectShow = this.state.projectShow
    const taskShow = this.state.taskShow
    let idx
    let hasData = false
    switch (type) {
      case ActionType.showProject:
        projectShow.push(data.pid)
        projectShow.sort()
        if (!taskShow.hasOwnProperty(data.pid)) {
          taskShow[data.pid] = []
        }
        this.setState({ projectShow, taskShow })
        break

      case ActionType.hideProject:
        this.state.records.map(record => {
          if (record.projectId === data.pid) {
            hasData = true
          }
        })

        if (hasData) {
          this.setState({ snackbarActive: true, snackbarText: '有資料，無法隱藏' })
        } else {
          idx = projectShow.indexOf(data.pid)
          if (idx > -1) {
            projectShow.splice(idx, 1)
          }
          this.setState({ projectShow })
        }
        break

      case ActionType.showTask:
        if (!taskShow.hasOwnProperty(data.pid)) {
          taskShow[data.pid] = []
        }
        taskShow[data.pid].push(data.tid)
        taskShow[data.pid].sort()
        this.setState({ taskShow })
        break

      case ActionType.hideTask:

        this.state.records.map(record => {
          if (record.projectId === data.pid && record.taskId === data.tid) {
            hasData = true
          }
        })

        if (hasData) {
          this.setState({ snackbarActive: true, snackbarText: '有資料，無法隱藏' })
        } else {
          idx = taskShow[data.pid].indexOf(data.tid)
          if (idx > -1) {
            taskShow[data.pid].splice(idx, 1)
          }
          this.setState({ taskShow })
        }
        break
      default:
        console.log(`Error: unknown ActionType: ${type}`)
    }
  }

  onWeekChange (shift) {
    let weekReport
    const monday = misc.getShiftedMonday(this.state.thisMonday, shift)
    const me = this.props.me
    const _this = this
    co(function *() {
      const { records, weekReports } = yield {
        records: aRecords.findWeek(me._id, monday),
        weekReports: aWeekReports.find(me._id, monday),
      }
      if (weekReports.length > 0) {
        weekReport = weekReports[0]
      } else {
        weekReport = {}
      }
      _this.setState({
        records,
        weekReport,
        thisMonday: monday,
      })
    }).catch(misc.onError)
  }

  onWeekReportChange (action, projectId, userId) {
    console.log('onWeekReportChange', action)
    let weekReport = {}
    const monday = this.state.thisMonday
    if (action === 'submit') {
      weekReport.userId = this.state.userId
      weekReport.monday = `${monday.year}-${monday.month}-${monday.date}`
      const overtime = {}
      this.state.records.forEach(record => {
        if (misc.getOTime(record) > 0) {
          if (overtime.hasOwnProperty(record.projectId)) {
            overtime[record.projectId] += misc.getOTime(record)
          } else {
            overtime[record.projectId] = misc.getOTime(record)
          }
        }
      })
      weekReport.reviews = []
      Object.keys(overtime).forEach(pid => {
        weekReport.reviews.push({ projectId: pid, state: '', userId: '', hHour: overtime[pid] })
      })

      const _this = this
      co(function *() {
        weekReport = yield aWeekReports.create(weekReport)
        _this.setState({ weekReport })
      }).catch(misc.onError)
    }

    if (action === 'withdraw') {
      const _this = this
      co(function *() {
        yield aWeekReports.del(_this.state.weekReport)
        _this.setState({ weekReport: {} })
      }).catch(misc.onError)
    }

    if (action === 'accept' || action === 'reject') {
      weekReport = misc.deepCopy(this.state.weekReport)
      weekReport.reviews = weekReport.reviews.map(review => {
        const newReview = misc.deepCopy(review)
        if (review.projectId === projectId) {
          newReview.state = action
          newReview.userId = userId
        }
        return newReview
      })

      this.setState({ weekReport })
      co(function *() {
        yield aWeekReports.update(weekReport)
      }).catch(misc.onError)
    }

    if (action === 'confirm') {
      weekReport = misc.deepCopy(this.state.weekReport)
      weekReport.isDone = true

      this.setState({ weekReport })
      co(function *() {
        yield aWeekReports.update(weekReport)
      }).catch(misc.onError)
    }
  }

  onContentCodeChange (pid, originContentId, targetContentId) {
    // filter client records for later server update
    const recordsToChange = misc.deepCopy(
      this.state.records.filter(record =>
        record.projectId === pid && record.taskId === originContentId
      )
    )

    // update client tShow
    if (this.state.taskShow[pid]) {
      this.state.taskShow[pid] = this.state.taskShow[pid].map(
        taskId => taskId === originContentId ? targetContentId : taskId
      )
      this.setState({ taskShow: this.state.taskShow })
    }

    // update client record
    this.state.records = this.state.records.map(record => {
      if (record.projectId === pid && record.taskId === originContentId) {
        Object.assign(record, { taskId: targetContentId })
      }
      return record
    })
    this.setState({ records: this.state.records })

    // update server record
    const ActionType = TimeSheetPage.RecordActionType
    for (let i = 0; i < recordsToChange.length; i++) {
      recordsToChange[i].taskId = targetContentId
      this.updateServerState(recordsToChange[i], ActionType.update)
    }
  }

  updateClientState (newRecord, action) {
    // update the client side states
    let records = misc.deepCopy(this.state.records)
    const recordIndex = misc.findRecordIndex(newRecord, records)
    const ActionType = TimeSheetPage.RecordActionType
    switch (action) {
      case ActionType.del:
        records = this.state.records.filter((record, i) => i !== recordIndex)
        break

      case ActionType.update:
        records[recordIndex] = newRecord
        break

      case ActionType.create:
        records.push(newRecord)
        break
      default:
    }
    this.setState({ records })
  }

  updateServerState (newRecord, action) {
    // update records at the server
    const _this = this
    let records
    let recordIndex
    let serverRecord
    const ActionType = TimeSheetPage.RecordActionType
    co(function*() {
      switch (action) {
        case ActionType.del:
          yield aRecords.del(newRecord)
          break

        case ActionType.update:
          yield aRecords.update(newRecord)
          break

        case ActionType.create:
          serverRecord = yield aRecords.create(newRecord)
          records = misc.deepCopy(_this.state.records)
          recordIndex = misc.findRecordIndex(serverRecord, records)
          records[recordIndex] = serverRecord
          _this.setState({ records })
          break
        default:
      }
    }).catch(misc.onError)
  }

  static RecordActionType = { del: 'del', update: 'update', create: 'create' };

  render () {
    const rawData = this.state
    rawData.me = this.props.me

    return (
      <div className={styles.timesheetPage}>
          <TimeSheet
            rawData={rawData}
            onRecordUpdate={this.onRecordUpdate}
            onShowChange={this.onShowChange}
            onWeekChange={this.onWeekChange}
            onImportLastWeek={this.onImportLastWeek}
            onWeekReportChange={this.onWeekReportChange}
            onContentCodeChange={this.onContentCodeChange}
            withControl
            reviewMode={!misc.isEmpty(this.state.weekReport)}
          />
          <Snackbar
            action="Dismiss"
            active={this.state.snackbarActive}
            style={{ padding: '1.4em 2.4em', marginTop: '1.4em' }}
            icon="question_answer"
            label={this.state.snackbarText}
            timeout={2000}
            onClick={this.onSnackbarClick}
            onTimeout={this.onSnackbarTimeout}
            type="cancel"
          />
      </div>
    )
  }
}

export default TimeSheetPage



// WEBPACK FOOTER //
// ./src/app/timesheetPage.jsx